"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlePropertiesUtil = void 0;
const ArticleProperties_1 = require("./ArticleProperties");
/**
 * Utility class for Article properties
 */
class ArticlePropertiesUtil {
    /**
     * Converts the article properties to a string representation.
     *
     * @param articleProperties The given article properties.
     */
    static toString(articleProperties) {
        if (articleProperties === ArticleProperties_1.ALL_ARTICLE_PROPERTIES) {
            return '';
        }
        return articleProperties.join(',');
    }
    static toArray(articleProperties) {
        if (articleProperties === ArticleProperties_1.ALL_ARTICLE_PROPERTIES) {
            return [];
        }
        return articleProperties.map((value) => value.toString());
    }
}
exports.ArticlePropertiesUtil = ArticlePropertiesUtil;
//# sourceMappingURL=ArticlePropertiesUtil.js.map